import { render, staticRenderFns } from "./commodity_snack.vue?vue&type=template&id=4c2fd0a6"
import script from "./commodity_snack.vue?vue&type=script&lang=js"
export * from "./commodity_snack.vue?vue&type=script&lang=js"
import style0 from "./commodity_snack.vue?vue&type=style&index=0&id=4c2fd0a6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports